// Alert Dialog component styles

export const alertDialogOverlayStyles = 
  "fixed inset-0 z-50 bg-black/80 " +
  "data-[state=open]:animate-in data-[state=closed]:animate-out " +
  "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0";

export const alertDialogContentStyles = 
  "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 " +
  "data-[state=open]:animate-in data-[state=closed]:animate-out " +
  "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 " +
  "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 " +
  "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] " +
  "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] " +
  "sm:rounded-lg";

export const alertDialogHeaderStyles = "flex flex-col space-y-2 text-center sm:text-left";

export const alertDialogFooterStyles = "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end";

export const alertDialogTitleStyles = "text-lg font-semibold";

export const alertDialogDescriptionStyles = "text-sm text-muted-foreground";

export const alertDialogCancelStyles = "";

